import React, { Component } from "react";
import { Link } from "react-router-dom";
import * as ROUTES from '../../../constants/routes';
import { connect } from 'react-redux';
import { signIn } from "../../../store/actions/authActions";

const formLabelStyle = {
    fontSize: "12px",
    fontWeight: "bold",
};

class LoginForm extends Component {
    constructor(props) {
        super(props)

        this.state = {
            email: "",
            password: "",
            isShowPassword: false,
        }
    }

    toggleShowPassword = () => {
        var isShowPassword = this.state.isShowPassword;
        this.setState({
            isShowPassword: !isShowPassword
        })
    }

    handleChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.signIn(this.state);
    }

    render() {
        // console.log(this.props);
        const { isShowPassword } = this.state;
        const { error, showLoader } = this.props.auth;
        const {isViaModal,modalTitleStyle} = this.props;
        const relevantSubmitComponent = showLoader && !error ?
            <button className="btn btn-flat btn-dark btn-sm" type="button" disabled>
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                &nbsp; Logging in
            </button> : <button className="btn btn-dark btn-sm" type="submit">Log me in</button>;

        return (
            <div className="container">
               <div className={isViaModal ? "":"card"}>
               <p style={modalTitleStyle} className={isViaModal?"":"card-header"}>Login to your account</p>
               <div className={isViaModal?"":"card-body"}>
                        <form onSubmit={this.handleSubmit}>

                            {/* EMAIL AND PASS */}
                            <div className="form-group text-left">
                                <label htmlFor="email" style={formLabelStyle}>Email</label>
                                <input type="email" className="form-control" id="email" onChange={this.handleChange} required />
                            </div>
                            <div className="form-group text-left">
                                <label htmlFor="password" style={formLabelStyle}>Password</label>
                                <input type={isShowPassword ? 'text' : 'password'} className="form-control" hidden={false} id="password" onChange={this.handleChange} required autoComplete="new-password" />
                            </div>
                            <div className="form-group text-right">
                                <span role="button" className="btn btn-link btn-sm" onClick={this.toggleShowPassword}>{isShowPassword ? 'Hide password' : 'Show password'}</span>
                            </div>
                            <div className="form-group text-right">
                                <Link to={ROUTES.FORGOT_PASS}>
                                    Forgot password?
                                </Link>
                            </div>

                            {/* ERROR */}
                            <p style={{ color: "red", fontWeight: "bold", fontSize: "13px" }}>{error ?? ""}</p>

                            {/* SIGN IN BUTTON */}
                            {relevantSubmitComponent}
                        </form>
                    </div>
                </div>
            </div>
        );
    }

}

const mapStateToProps = (state) => {
    // console.log(state.auth)
    return {
        auth: state.auth,
        themeColors: state.theme,
        modalStyles: state.appControl.modalStyles,
        modalTitleStyle: state.appControl.modalTitleStyle,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        signIn: (credentials) => dispatch(signIn(credentials)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm);